module.exports = __webpack_public_path__ + "static/img/14.82b4c48.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/carrusel/14.png
// module id = EsEo
// module chunks = 5